// extracted by mini-css-extract-plugin
export default {"app":"App_app__twZXI","placeholder":"App_placeholder__feDvL","comingSoon":"App_comingSoon__ugt4u","pulse":"App_pulse__ZKI4s","notFound":"App_notFound__Xrgvj"};